import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const LoadingState = () => (
  <div style={{ 
    minHeight: '100vh', 
    background: 'var(--bg-primary)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: '20px'
  }}>
    <div className="spinner" style={{ 
        width: '40px', 
        height: '40px', 
        border: '3px solid rgba(240, 185, 11, 0.1)', 
        borderTop: '3px solid var(--primary-accent)', 
        borderRadius: '50%',
        animation: 'spin 1s linear infinite'
    }} />
    <div style={{ color: 'var(--text-secondary)', fontSize: '14px', letterSpacing: '1px' }}>RE-ESTABLISHING SECURE CONNECTION...</div>
    <style>{`
        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }
    `}</style>
  </div>
);

export function ProtectedRoute({ children, adminOnly = false }) {
  const { user, isAdmin, isAgent, loading } = useAuth();
  const location = useLocation();

  if (loading) return <LoadingState />;

  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  
  if (adminOnly && !isAdmin) return <Navigate to="/dashboard" replace />;

  // Restrict agents to their dashboard only
  if (isAgent && !isAdmin) return <Navigate to="/agent/dashboard" replace />;
  
  return children;
}

export function AdminRoute({ children }) {
  const { user, isAdmin, isAgent, loading } = useAuth();
  const location = useLocation();

  if (loading) return <LoadingState />;

  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  
  if (!isAdmin && !isAgent) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
}

export function AgentRoute({ children }) {
  const { user, isAdmin, isAgent, loading } = useAuth();
  const location = useLocation();

  if (loading) return <LoadingState />;

  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  // Agents or Admins can access agent dashboard
  if (!isAdmin && !isAgent) return <Navigate to="/dashboard" replace />;
  return children;
}

export function GuestRoute({ children }) {
  const { user, isAdmin, isAgent, loading } = useAuth();
  
  if (loading) return <LoadingState />;
  
  if (user) {
    if (isAdmin) return <Navigate to="/admin" replace />;
    if (isAgent) return <Navigate to="/agent/dashboard" replace />;
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
